import { useEffect } from "react";

const BASE_URL = process.env.REACT_APP_BACKEND_URL || "";

function upsert(selector, attr, key, content) {
  if (!content) return null;
  let el = document.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
  return el;
}

function setName(name, content) {
  return upsert(`meta[name="${name}"]`, "name", name, content);
}

function setProp(prop, content) {
  return upsert(`meta[property="${prop}"]`, "property", prop, content);
}

function setCanonical(href) {
  if (!href) return;
  let el = document.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export function useSeo({ title, description, keywords, image, path, type = "website", jsonLd }) {
  useEffect(() => {
    if (title) document.title = title;
    setName("description", description);
    setName("keywords", keywords);

    const url = path ? `${BASE_URL}${path}` : window.location.href;
    setCanonical(url);

    // Open Graph
    setProp("og:title", title);
    setProp("og:description", description);
    setProp("og:type", type);
    setProp("og:url", url);
    setProp("og:site_name", "Licence to Play");
    setProp("og:image", image);

    // Twitter
    setName("twitter:card", image ? "summary_large_image" : "summary");
    setName("twitter:title", title);
    setName("twitter:description", description);
    setName("twitter:image", image);

    const scripts = [];
    const blocks = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];
    blocks.forEach((block) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.className = "seo-jsonld";
      s.text = JSON.stringify(block);
      document.head.appendChild(s);
      scripts.push(s);
    });

    return () => scripts.forEach((s) => s.remove());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, description, keywords, image, path, type, JSON.stringify(jsonLd)]);
}
